import CarNamesIcon from '@material-ui/icons/TimeToLeave';
import ManageElectric from './ManageElectric';

export default {
  name: 'ElectricCarNameManagement',
  list: ManageElectric,
  icon: CarNamesIcon,

  options: {
    label: 'רכבים חשמליים',
    group: 'names-management'
  }
};
